import { render, staticRenderFns } from "./SetPermission.vue?vue&type=template&id=4b4f6dc2"
import script from "./SetPermission.vue?vue&type=script&lang=js"
export * from "./SetPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports